








































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import Swiper from 'swiper';
import TextCom from '../text/index.vue';
import { i18n } from '@/i18n';
import { NoticeItem, NoticeItemType } from '@/types/index';
import { windowHelper } from '@tencent/ppd-base-libs';

@Component({
  components: {
    TextCom,
  },
})
export default class Notice extends Vue {
  /** 滚动文字数组 */
  @Prop() textArr!: NoticeItem[];
  /** 数组为空时的兜底文案 */
  @Prop() emptyText!: string;
  @Prop() swiperClass!: string;
  public mySwiper: Swiper;

  // return `獲贈${item.prize_name} × ${item.count} - ${item.create_time.slice(0, 10)}`
  /** 是否有消息通知 */
  get isHasNotice() {
    return this.textArr.length > 0;
  }
  activeIndex = 0;

  formatContent(content, type) {
    if (type === NoticeItemType.EStamp) {
      return `${i18n('获赠')}${content}`;
    }
    return content;
  }

  getPrizeTime(date) {
    return date.substr(0, 10);
  }

  @Emit('noticeClick')
  handleClick() {
    const item = this.textArr[this.activeIndex];
    if (item && (item.click || item.url)) {
      item.click ? item.click.apply(this) : windowHelper.redirect(item.url, 300);
    } else {
      this.goDiscountRecord();
    }
  }

  /** 跳转优惠详情 */
  public goDiscountRecord() {
    this.$router.push({ name: 'discountrecord' });
  }
  mounted() {
    this.mySwiper = new Swiper(this.swiperClass ? `.${this.swiperClass}` : '.swiper-wrapper-prom', {
      centeredSlides: true,
      watchOverflow: true, // 因为仅有1个slide，swiper无效
      autoHeight: true,
      autoplay: {
        delay: 3000, // 1秒切换一次
        disableOnInteraction: false,
        reverseDirection: false,
      },
      speed: 500,
      observer: true, // 修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, // 修改swiper的父元素时，自动初始化swiper
      direction: 'vertical', // 垂直切换选项
      noSwiping: true,
      on: {
        slideChange: () => {
          if (!this.mySwiper) {
            return;
          }
          const index = this.mySwiper.realIndex;
          this.activeIndex = index;
        },
      },
    });
  }
}
